import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';
import MobileOffcanvas from './MobileOffcanvas';
import { selectIsAuthed, selectUserInfo } from '../../selectors/userSelectors';

function sumValues(map) {
  if (!map) return 0;
  let total = 0;
  for (const key in map) total += Number(map[key]) || 0;
  return total;
}

function Navbar() {
  // Phase 5 R5.2 — auth-gate read goes through selectIsAuthed.
  // Composes through selectAccessToken, so Phase 6 ownership swap
  // (legacy → state.auth.access) is transparent here.
  const isAuthed = useSelector(selectIsAuthed);
  const userInfo = useSelector(selectUserInfo);
  const userImage = userInfo?.user_image ?? null;

  const unreadChats = useSelector((state) =>
    sumValues(state.chat?.unreadByChat)
  );

  const unreadNotifications = useSelector(
    (state) => state.notifications?.unreadCount ?? 0
  );

  const navProps = useMemo(
    () => ({
      isAuthed,
      badges: { unreadChats, unreadNotifications },
    }),
    [isAuthed, unreadChats, unreadNotifications]
  );

  return (
    <>
      <DesktopNavbar {...navProps} userImage={userImage} />
      <MobileNavbar {...navProps} />
      <MobileOffcanvas {...navProps} />
    </>
  );
}

export default Navbar;
